import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CookieService } from 'ngx-cookie-service'
import { PkwDataModule } from '../pkw-data/pkw-data.module'
import { GestorDeErros } from './gestor-de-erros'
import { BureauService } from './services/bureau.service'
import { EmpresaQueVendeComCartoesService } from './services/empresa-que-vende-com-cartoes.service'
import { EmpresaService } from './services/empresa.service'
import { OperadorService } from './services/operador.service'
import { OperadoraDeMaquinaService } from './services/operadora-de-maquina.service'
import { SchemaService } from './services/schema.service'

@NgModule({
    imports: [CommonModule, PkwDataModule],
    declarations: [],
    providers: [
        CookieService,
        SchemaService,
        BureauService,
        EmpresaService,
        OperadorService,
        EmpresaQueVendeComCartoesService,
        OperadoraDeMaquinaService,
        GestorDeErros,
    ],
    exports: [PkwDataModule],
})
export class AppCoreModule {}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts